<div class="d-flex">
    <button type="button" class="context-menu icon-btn fill-valyrianSteel fill-hover-whaleTail" [popover]="popoverTemplate" #actionPopover="bs-popover"
        triggers="manual" container=".cx-one-ui" [outsideClick]="true" containerClass="cxone-popover" (click)="refresh(params); showPopover($event);">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
        <ng-template #popoverTemplate>
            <div class="more-option-popover">
                <ul>
                    <li class="clickable" id="edit-action-btn" (click)="editClick()" *ngIf="definition.IsEditable">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Edit">Edit</span>
                    </li>
                    <li class="clickable" id="duplicate-action-btn" (click)="duplicateClick()" *ngIf="showDuplicateBtn">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/duplicate.svg#duplicate"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Duplicate">Duplicate</span>
                    </li>
                    <li class="clickable" id="recalculate-action-btn"
                        [ngClass]="{ 'option-disabled': definition.Type !== 0 || recalculationInProgress}"
                        (click)="recalculateClick()">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/generate-schedule.svg#generate-schedule"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Recalculation">Recalculation</span>
                    </li>
                    <li class="clickable" id="delete-action-btn" (click)="deleteClick(popoverRef)" [ngbPopover]="deleteModal"
                    triggers="manual" container="body" placement="left" #popoverRef="ngbPopover"
                        *ngIf="definition.IsEditable"  popoverClass="cxoneConfirmDashboardDeletePopover">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Delete">Delete</span>
                    </li>
                </ul>
            </div>
        </ng-template>
    </button>
    <ng-template #deleteModal>
        <div>
            <div class="popoverText" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Metric_Delete_Confirm">
                Deleting metrics may affect associated dashboards.
            </div>
            <div class="confirmBtns">
                <button type="button" class="cxone-btn btn-medium btn-popover"
                    style="margin-right: 10px; width: fit-content">
                    <span cvLocalizedText langSection="Dashboards_Landing" langKey="Cancel_Button"
                        style="margin-top: 4px;">Cancel</span>
                </button>
                <button type="button" (click)="confirmDelete()" class="cxone-btn btn-medium btn-primary deletebtn"
                    style="position: relative; top: 3px; width: fit-content">
                    <span cvLocalizedText langSection="Dashboards_Landing" langKey="Delete_Button">Delete</span>
                </button>
            </div>
        </div>
    </ng-template>
</div>
